import { render, staticRenderFns } from "./FifaRecap2022.vue?vue&type=template&id=4ba1acb9&scoped=true&"
import script from "./FifaRecap2022.vue?vue&type=script&lang=js&"
export * from "./FifaRecap2022.vue?vue&type=script&lang=js&"
import style0 from "./FifaRecap2022.vue?vue&type=style&index=0&id=4ba1acb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba1acb9",
  null
  
)

export default component.exports